import { EFileType } from '@/constant';
import { GetCommonNoticeListResponse } from '@/services';

import { formatDate, getImageIdsFromContentEditor, map } from 'utils';

export const formatCommonNoticeDetail = (
	input: GetCommonNoticeListResponse['content'][number]
) => {
	return {
		...input,
		initialImageIds: getImageIdsFromContentEditor(input.content),
		initialContent: input.content,
		registDt: formatDate(input.registDt),
		updateDt: formatDate(input.updateDt),
		fileList: input?.files?.map((file) => ({
			...file,
			uid: file.fileId,
			fileType: EFileType.SERVER,
			size: file.fileSize,
		})),
		targetProgramId: String(input.targetProgramId)?.includes('ALL')
			? input.targetProgramId
			: Number(input.targetProgramId),
		targetDistrictId: String(input.targetDistrictId)?.includes('ALL')
			? input.targetDistrictId
			: Number(input.targetDistrictId),
	};
};

export const formatCommonNoticeList = (
	input: GetCommonNoticeListResponse['content']
) => {
	return map(input, formatCommonNoticeDetail);
};
